import { ICFConfig } from './configs/icf'
import IchimokuCloud from './ic'

class IchimokuCloudFull extends IchimokuCloud {
  static config = ICFConfig
  static renderFull = true
}

export default IchimokuCloudFull
